import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Cookies } from 'react-cookie';
import get from 'lodash/get';
import merge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';
import { injectIntl } from 'react-intl';
import { Ad } from '@dmm/react-common-components';
import { adsConfig, getTargeting } from './resources/adsConfig';
import adParams from './resources/adParams';
import { isMobileResolution } from '../../../../utils/commonHelper';
import AdProvider from '../../../../components/Ads/AdProvider';
import MobileRefineSearch from '../components/MobileRefineSearch';
import RefineSearchSideBar from '../components/RefineSearchSideBar';
import RelatedContent from '../components/RelatedContent';
import SeoContent from '../../components/SeoContent';
import ResultsHeader from '../components/ResultsHeader';
import ResultsPagination from '../components/ResultsPagination';
import TypeChooser from '../../components/TypeChooser';
import TypeChooserBranded from '../../components/TypeChooser/Branded';
import AlertMessage from '../../../../components/AlertMessage';
import BrandedHeader from '../../../BrandedSearch/components/BrandedHeader';
import BrandedHeaderV2 from '../../../BrandedSearch/components/BrandedHeaderV2';
import BreadCrumb from '../../../../components/BreadCrumb';
import EnginesList from '../components/EnginesList';
import LoadingEnginesList from '../components/EnginesList/LoadingEnginesList';
import Meta from '../../../../components/Meta';
import { getBreadCrumb } from '../../utils/engineBreadcrumb';
import * as meta from '../../utils/meta';
import * as enginesMeta from '../utils/meta';
import {
  getTitle,
  getPrice,
  getLocation
} from '../../../../utils/listingHelper';

import { setProductImpression } from '../../../../store/actions/dataLayer';
import {
  getDefaultParams,
  parseSearchParams
} from '../../../../utils/urlHelpers/engines';
import { getNumberOfPages } from '../../../../utils/paginationHelper';
import { getEngineUrl } from '../../../../utils/urlHelpers/engine';
import { listingPropTypes } from '../../../../utils/commonPropTypes';
import { PortalConfigContext } from '../../../../config/portal';
import * as utils from '../../../../store/utils';
import * as storage from '../../../../utils/storage';
import {
  REDUCTION_REDIRECT_COOKIE,
  UNAVAILABILITY_REDIRECT_COOKIE
} from '../../../../constants/cookies';
import * as scroll from '../../../../utils/scrollTo';
import SponsoredListings from '../../components/SponsoredListings';
import { getPortalName } from '../../../../utils/language';

import './styles.css';
import { getMessages } from '../../../../tppServices/translations/messages';

class MainContent extends PureComponent {
  state = {
    alert: null,
    isMobileResolution: false
  };
  constructor(props) {
    super(props);
    this.translationMessages = getMessages();
  }

  getEnginesBreadCrumb(defaultParams, seoParams) {
    const messages = this.translationMessages;
    const {
      intl: { formatMessage: t }
    } = this.props;
    const breadcrumbData = getBreadCrumb(defaultParams, seoParams);
    breadcrumbData[1].title = t(messages.header.enginesForSale);
    return breadcrumbData;
  }

  populateAlertMessage = () => {
    const {
      cookies,
      intl: { formatMessage: t }
    } = this.props;
    const messages = this.translationMessages;

    if (cookies.cookies[REDUCTION_REDIRECT_COOKIE]) {
      this.setState({
        alert: {
          mainText: t(messages.alertMessage.linkExpired.title),
          secondaryText: t(messages.alertMessage.linkExpired.description),
          url: get(this.props, 'location.pathname')
        }
      });
    } else if (cookies.cookies[UNAVAILABILITY_REDIRECT_COOKIE]) {
      this.setState({
        alert: {
          mainText: t(messages.alertMessage.boatUnavailable.title),
          secondaryText: t(messages.alertMessage.boatUnavailable.description),
          url: get(this.props, 'location.pathname')
        }
      });
    }

    cookies.remove(UNAVAILABILITY_REDIRECT_COOKIE, { path: '/' });
    cookies.remove(REDUCTION_REDIRECT_COOKIE, { path: '/' });
  };

  resizeHandler = () => {
    this.setState({
      isMobileResolution: isMobileResolution()
    });
  };

  saveSearchResults = () => {
    const nextPreviousData = {};
    const searchUrl = get(this.props, 'location.pathname', '');
    nextPreviousData.searchParams = parseSearchParams(
      searchUrl,
      this.props.mode === MainContent.MODES.branded
    );
    nextPreviousData.searchUrl = searchUrl;
    nextPreviousData.pageLow = parseInt(nextPreviousData.searchParams.page);
    const records = get(this.props, 'search.records', []);
    nextPreviousData.urls = records.map((listing) => getEngineUrl(listing));
    storage.setItem(
      'nextPreviousEnginesData',
      JSON.stringify(nextPreviousData)
    );
  };

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
    this.populateAlertMessage();
  }

  componentDidUpdate(prevProps) {
    if (!utils.isServer()) {
      this.saveSearchResults();
    }
    if (
      this.state.alert &&
      get(this.props, 'location.pathname') !==
        get(prevProps, 'location.pathname')
    ) {
      this.setState({ alert: null });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  paginationClickHandler() {
    scroll.scrollTo('#root');
  }

  renderHeader(seoParams, maxPages, portal, supportsBrandedHeaderV2) {
    const { mode, partyDetails } = this.props;

    if (mode === MainContent.MODES.branded) {
      if (supportsBrandedHeaderV2) {
        return (
          <BrandedHeaderV2
            bannerPath={partyDetails.bannerPath}
            description={partyDetails.description}
            multiLangDescriptions={partyDetails.multiLangDescriptions}
            logoPath={partyDetails.logoPath}
            displayName={partyDetails.displayName}
            seoParams={seoParams}
            portal={portal}
            address={partyDetails.address}
            type={BrandedHeaderV2.SEARCH_TYPE.engines}
          />
        );
      }
      return (
        <BrandedHeader
          bannerPath={partyDetails.bannerPath}
          description={partyDetails.description}
          multiLangDescriptions={partyDetails.multiLangDescriptions}
          logoPath={partyDetails.logoPath}
          displayName={partyDetails.displayName}
          seoParams={seoParams}
          portal={portal}
        />
      );
    }

    return <h1>{enginesMeta.getH1(seoParams, portal, false, {})}</h1>;
  }

  getSponsoredEngines() {
    const sponsored = get(this.props, 'sponsored.records', []);
    return sponsored.map((listing) => {
      listing.href = getEngineUrl(listing);
      return listing;
    });
  }

  render() {
    const params = get(this.props, 'match.params', {});
    const owner = get(this.props, 'match.params.owner', '');
    const makeModel = get(this.props, 'facets.makeModel', []);
    const facets = get(this.props, 'facets', {});
    const records = get(this.props, 'search.records', []);
    const defaultParams = getDefaultParams(params);
    const pos = { page: defaultParams.page, pageSize: defaultParams.pageSize };
    const { isMobileResolution } = this.state;
    const isTypeChooserEnabled = get(
      this.context,
      'pages.engineSearch.typeChooser.enabled'
    );
    const portal = getPortalName(this.context);
    const contextAdParams = get(
      this.context,
      'pages.engineSearch.adsConfig',
      {}
    );
    const pageAdsConfig = merge(contextAdParams, adsConfig);
    const url = get(this.props, 'location.pathname', '');
    const maxPages = get(
      this.context,
      'pages.engineSearch.pagination.maxPages',
      357
    );
    const seoParams = enginesMeta.getSEOParams(params, makeModel);
    const { mode, partyDetails } = this.props;
    const toggleProductsFeatureAvailable = get(
      partyDetails,
      'hasBothProductsEnginesAndBoats',
      false
    );
    const countListings = get(this.props, 'search.count', undefined);
    const numPages =
      getNumberOfPages(countListings, params) < maxPages
        ? getNumberOfPages(countListings, params)
        : maxPages;
    const currentPage = get(params, 'page', 1);
    let dealer;
    const isBranded = mode === MainContent.MODES.branded;
    if (isBranded) {
      let dealerAddress;
      if (records.length) {
        dealerAddress = get(
          this.props.search.records[0],
          'owner.location.address'
        );
      }
      dealer = {
        id: defaultParams.owner.split('-').pop(),
        dealerLocation: dealerAddress
      };
    }
    const targeting = getTargeting(defaultParams, dealer);

    const supportsBrandedHeaderV2 = get(
      this.context,
      'supports.brandedHeaderV2',
      false
    );
    const isSrpSeoEnabled = get(this.context, 'supports.enableSrpSeo', true);
    const contentHeadClassName =
      this.props.mode === MainContent.MODES.branded && supportsBrandedHeaderV2
        ? 'content-head-v2'
        : 'content-head';
    const noBoatListAds = get(this.context, 'supports.noBoatListAds', false);
    return (
      <>
        <AdProvider
          url={url}
          isWorking={this.props.isWorking}
          targeting={targeting}
          adsConfig={pageAdsConfig}
        >
          {(!isBranded || (isBranded && !isEmpty(partyDetails))) && (
            <Meta
              noindex={enginesMeta.getNoIndex(url, isBranded)}
              nofollow={enginesMeta.getNoFollow(url, isBranded)}
              canonical={enginesMeta.getCanonical(
                params,
                isBranded,
                partyDetails
              )}
              next={meta.getLinkRelNext()}
              prev={meta.getLinkRelPrev()}
              title={enginesMeta.getMetaTitle(
                seoParams,
                numPages,
                portal,
                isBranded,
                partyDetails
              )}
              description={enginesMeta.getMetaDescription(
                seoParams,
                numPages,
                portal,
                isBranded,
                partyDetails,
                countListings
              )}
            />
          )}
          <div className={contentHeadClassName}>
            <BreadCrumb
              items={this.getEnginesBreadCrumb(defaultParams, seoParams)}
            />
            {this.renderHeader(
              seoParams,
              numPages,
              portal,
              supportsBrandedHeaderV2
            )}
          </div>
          <div className="main-content">
            {!isMobileResolution && (
              <div id="left-content">
                {isTypeChooserEnabled && mode === MainContent.MODES.results && (
                  <TypeChooser url={url} />
                )}
                {toggleProductsFeatureAvailable && (
                  <TypeChooserBranded url={url} owner={owner} />
                )}
                <RefineSearchSideBar {...this.props} />
                {!noBoatListAds && (
                  <div id="right-ad" className="sticky-ads">
                    <Ad {...adParams.sideBarBox1Params} />
                    <Ad {...adParams.sideBarBox2Params} />
                  </div>
                )}
              </div>
            )}
            <div id="right-content">
              {isMobileResolution && <MobileRefineSearch {...this.props} />}
              {this.props.sponsored && this.props.sponsored.records ? (
                <SponsoredListings
                  sponsoredListings={this.getSponsoredEngines()}
                  isLoading={this.props.isWorking}
                  url={url}
                  isEngine
                />
              ) : null}
              <div className="search-results">
                <ResultsHeader {...this.props} isMobile={isMobileResolution} />
                <Ad {...adParams.sponsoredAdsParams} />
                {this.state.alert && (
                  <AlertMessage
                    mainText={this.state.alert.mainText}
                    secondaryText={this.state.alert.secondaryText}
                  />
                )}
                {!this.props.isWorking ? (
                  <EnginesList
                    adParams={adParams}
                    showAds={!noBoatListAds}
                    listings={records}
                    history={this.props.history}
                    url={url}
                    pos={pos}
                    labels={{
                      getTitle: getTitle,
                      getPrice: getPrice,
                      getLocation: getLocation
                    }}
                    tracking={{
                      setProductImpression: this.props.setProductImpression
                    }}
                  />
                ) : (
                  <LoadingEnginesList number={28} />
                )}
                <ResultsPagination
                  {...this.props}
                  searchType={this.props.searchType}
                  maxPages={maxPages}
                  onClick={this.paginationClickHandler}
                />
                {isSrpSeoEnabled &&
                currentPage === 1 &&
                !this.props.isWorking ? (
                  <SeoContent params={params} />
                ) : null}
                <RelatedContent params={params} facets={facets} />
              </div>
            </div>
          </div>
        </AdProvider>
      </>
    );
  }
}

MainContent.MODES = {
  results: 'results',
  branded: 'branded'
};

MainContent.defaultProps = {
  mode: MainContent.MODES.results,
  partyDetails: {}
};

MainContent.propTypes = {
  cookies: PropTypes.instanceOf(Cookies),
  history: PropTypes.object,
  isWorking: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  mode: PropTypes.oneOf(Object.keys(MainContent.MODES)),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  partyDetails: PropTypes.shape({
    bannerPath: PropTypes.string,
    description: PropTypes.string,
    logoPath: PropTypes.string,
    name: PropTypes.string,
    displayName: PropTypes.string,
    normalizedName: PropTypes.string,
    address: PropTypes.object,
    multiLangDescriptions: PropTypes.object,
    hasBothProductsEnginesAndBoats: PropTypes.bool
  }),
  search: PropTypes.shape({
    records: PropTypes.arrayOf(listingPropTypes),
    count: PropTypes.number
  }),
  searchType: PropTypes.string,
  setProductImpression: PropTypes.func.isRequired,
  sponsored: PropTypes.shape({
    records: PropTypes.arrayOf(listingPropTypes),
    count: PropTypes.number
  })
};

MainContent.contextType = PortalConfigContext;

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      setProductImpression
    },
    dispatch
  )
)(injectIntl(MainContent));
